module.exports = __webpack_public_path__ + "static/impact-989e44929f6a03102d66e8d21e93333a.woff2";